import cn from 'clsx';
import { AriaAttributes, forwardRef, Ref } from 'react';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  onClick?: () => void;
  icon: IconLookup;
  iconClassName?: string;
  className?: string;
  ariaLabel: AriaAttributes['aria-label'];
};

function IconButton({ onClick, icon, ariaLabel, className, iconClassName }: Props, ref: Ref<any>) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'inline-flex cursor-pointer text-2xl group',
        'text-slate-800 hover:text-slate-900 active:text-slate-950',
        className
      )}
      aria-label={ariaLabel}
      ref={ref}
    >
      <div
        className={cn(
          'w-9 h-9 flex items-center justify-center rounded-md',
          'bg-white group-hover:bg-slate-100 group-active:bg-slate-200'
        )}
      >
        <FontAwesomeIcon icon={icon} className={iconClassName} />
      </div>
    </button>
  );
}

export default forwardRef(IconButton);
